import { Spin } from 'antd';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SortCondition } from 'shared/enums';
import { PollTabs, SearchKeysPoll } from 'shared/enums/poll';
import { dataForPollsInfoTable, sortingDate } from 'shared/helpers/utils';
import { usePullSort } from 'shared/hooks';
import { TPollSearchType, TPollsColumns } from 'shared/types/poll.types';
import PollTable from 'features/tables/pollsTable';
import { useLazyGetPollQuery } from 'app/services/edpApiV1/poll';

const PollPublicated = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [searchObject, setSearchObject] = useState<TPollSearchType>({
    data: undefined,
    key: SearchKeysPoll.SEARCH_NAME,
  });
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const navigate = useNavigate();
  const [sortInfo, trigger] = usePullSort();

  const { search } = useAppSelector(state => state.entities.search);

  const [getPollLazy, result] = useLazyGetPollQuery();

  const onSearch = (data: string, key: SearchKeysPoll) => {
    setSearchObject({ data: data ? data : undefined, key });
  };

  useEffect(() => {
    getPollLazy({
      size: currentSize,
      page: currentPage,
      type: PollTabs.PUBLICATED,
      orderDate: sortInfo.value ? sortInfo.value : undefined,
      [searchObject.key]: searchObject.data,
    });
  }, [currentPage, currentSize, getPollLazy, search, sortInfo.value, searchObject]);

  const onclickToRow = (id: number) => {
    navigate(`/polls/info/${id}`);
  };

  const columns: TPollsColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Дата',
      dataIndex: 'created',
      key: 'created',
      sortDirections: [SortCondition.ASCEND, SortCondition.DESCEND],
      sorter: true,
      onHeaderCell: _ => ({
        onClick: () => trigger(),
      }),
    },
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Автор',
      dataIndex: 'fio',
      key: 'fio',
    },
  ];
  return (
    <>
      <Spin spinning={result.isLoading || result.isFetching}>
        {result.data?.data ? (
          <PollTable
            dataSource={dataForPollsInfoTable(result?.data?.data) || []}
            columns={columns}
            currentPage={currentPage}
            currentSize={currentSize}
            setCurrentPage={setCurrentPage}
            setCurrentSize={setCurrentSize}
            total={result.data?.pagination.total}
            onclickToRow={data => onclickToRow(data)}
            onSearch={onSearch}
          />
        ) : null}
      </Spin>
    </>
  );
};

export default PollPublicated;
